import { Block, Icon, Text, Tooltip } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { copyToClipboardNotify } from 'Services/copyToClipboard';
import T from 'Components/Helpers/translate';
import './CopyableId.scss';
import StateRouter from 'App/services/StateRouter';

export type CopyableIdType = 'order' | 'projectPlan';

type CopyableIdProps = React.ComponentProps<typeof Block> & {
	objectId: number;
	type: CopyableIdType;
	loading?: boolean;
	size?: React.ComponentProps<typeof Text>['size'];
	color?: React.ComponentProps<typeof Text>['color'];
};

const getLinkByType = (type: CopyableIdType, objectId: number) => {
	switch (type) {
		default:
			return `${location.host}/${StateRouter.href('react-root-open', { type, id: objectId })}`;
	}
};

const CopyableId = ({
	type,
	objectId,
	loading,
	size = 'sm',
	color = 'grey-10',
	className,
	...blockProps
}: CopyableIdProps) => {
	const classes = useMemo(() => new BemClass('CopyableId', className), []);
	const [copied, setCopied] = useState(false);

	// Queue copied=false on copy
	useEffect(() => {
		let timeout: NodeJS.Timeout;
		if (copied) {
			timeout = setTimeout(() => setCopied(false), 1000);
		}
		return () => clearTimeout(timeout);
	}, [copied]);

	// Copy link to clipboard and set copied=true
	const copyLink = useCallback(() => {
		copyToClipboardNotify(getLinkByType(type, objectId));
		setCopied(true);
	}, [type, objectId]);

	return (
		<Block {...blockProps} className={classes.b()}>
			<Text size={size} color={color} loading={loading}>
				{'ID: ' + objectId}
			</Text>
			<Tooltip
				className={classes.elem('icon').b()}
				disabled={copied}
				title={T('default.copyLink')}
				position="right"
			>
				<Icon name="link" color="grey-10" space="mlm mrm" onClick={copyLink} />
			</Tooltip>
		</Block>
	);
};

export default CopyableId;
